import { Box, styled } from "@mui/material";

interface StyledGraphicWrapperProps {
  isDisabled?: boolean;
  isSelected: boolean;
}

const NON_FORWARDING_GRAPHIC_WRAPPER_PROPS = ["isSelected", "isDisabled"];

export const StyledGraphicWrapper = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !NON_FORWARDING_GRAPHIC_WRAPPER_PROPS.includes(prop),
})<StyledGraphicWrapperProps>`
  position: relative;
  cursor: pointer;

  ${({ theme: { wsc } }) => `
    color: ${wsc.palette.neutral[200]};
  `};

  ${({ theme: { wsc }, isDisabled, isSelected }) =>
    !isDisabled &&
    !isSelected &&
    `
    &:hover {
      color: ${wsc.palette.neutral[100]};

      & .graphic-content {
        border-color: ${wsc.palette.neutral[300]};
      }
      
      & .graphic-hover-plus-icon {
        opacity: 1;
      }
    }
  `}

  ${({ theme: { wsc }, isSelected }) =>
    isSelected &&
    `
    color: ${wsc.palette.primary[300]};
    
    & .graphic-content {
      border-color: ${wsc.palette.primary[300]};
    }

  `}

  ${({ theme: { wsc }, isDisabled }) =>
    isDisabled &&
    `
        & img,
        video {
          opacity: 0.4;
        };

        cursor: default;
        color: ${wsc.palette.neutral[400]};
    `}
`;

export const StyledGraphicHoverIcon = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  z-index: 1;
  transition: all 0.15s;

  ${({ theme: { wsc } }) => `
    width: calc(${wsc.size.m} * 2);
    height: calc(${wsc.size.m} * 2);
    background-color: ${wsc.palette.primary[300]};
    border-radius: ${wsc.radius.m};
    color: ${wsc.palette.neutral[600]};
  `}
`;

const NON_FORWARDING_CONTENT_WRAPPER_PROP = "isSelected";

export const StyledGraphicContentWrapper = styled(Box, {
  shouldForwardProp: (prop: string) =>
    prop !== NON_FORWARDING_CONTENT_WRAPPER_PROP,
})<{ isSelected: boolean }>`
  position: relative;
  transition: all 0.15s;
  overflow: hidden;

  ${({ theme: { wsc }, isSelected }) => `
    height: calc(${wsc.size.xxl} * 2.25);
    border-radius: ${wsc.radius.m};
    border: 1px solid ${wsc.palette.neutral[500]};
    ${Boolean(isSelected) && `padding: calc(${wsc.spacing[0]} / 2)`};
  `}
`;

export const StyledGraphicVideo = styled("video")`
  object-fit: cover;
  height: 100%;
  width: 100%;
  transition: all 0.15s;
  border-radius: calc(${({ theme: { wsc } }) => wsc.radius.m} - 1px);
`;

export const StyledGraphicImage = styled("img")`
  object-fit: cover;
  height: 100%;
  width: 100%;
  transition: all 0.15s;
  border-radius: calc(${({ theme: { wsc } }) => wsc.radius.m} - 1px);
`;

export const StyledGraphicName = styled(Box)`
  ${({ theme: { wsc } }) => wsc.typography.body2};

  margin-top: ${({ theme: { wsc } }) => `calc(${wsc.spacing[0]} * 2.5)`};
  transition: all 0.15s;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
